import useSearch from './use-search';
import useFilters from './use-filters';

const toggleInArray = (source, value) => {
  const asArray = [...(Array.isArray(source) ? source : [source].filter(Boolean))];
  const result = asArray.includes(value)
    // if it's present, toggle it out
    ? asArray.filter((v) => v !== value)
    // value could be "", filter it out
    : asArray.concat(value).filter(Boolean);
  if (result.length === 0) {
    return undefined;
  }
  return result;
};

const emptyStringIsUndefined = (value) => {
  if (value === '') {
    return undefined;
  }
  return value;
};

const useField = (field) => {
  const {
    where,
    setWhere,
    defaultValues,
  } = useSearch();
  const filterValues = useFilters();

  const handleKeyValueToggle = ({ target: { value } }) => setWhere({
    ...where,
    [field]: value === where[field] ? undefined : emptyStringIsUndefined(value),
  });

  const handleKeyValueArrayToggle = ({ target: { value } }) => setWhere({
    ...where,
    [field]: toggleInArray(where[field], value),
  });

  if (field === 'make') {
    return {
      value: where.make || defaultValues.make,
      options: filterValues.allMakes,
      handler: ({ target: { value } }) => setWhere({
        ...where,
        make: value === where.make ? undefined : emptyStringIsUndefined(value),
        model: undefined, // a specific make model should be cleared when clearing the make
      }),
      arrayHandler: ({ target: { value } }) => setWhere({
        ...where,
        make: toggleInArray(where.make, value),
        model: undefined, // a specific make model should be cleared when clearing the make
      }),
    };
  }
  if (field === 'model') {
    return {
      value: where.model,
      options: filterValues.modelsForSelectedMake,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'buildyear_min') {
    return {
      value: where.buildyear_min,
      options: filterValues.buildyears,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'buildyear_max') {
    return {
      value: where.buildyear_max,
      options: filterValues.buildyears,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'body') {
    return {
      value: where.body,
      options: filterValues.bodies,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'fuel') {
    return {
      value: where.fuel,
      options: filterValues.fuels,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'transmission') {
    return {
      value: where.transmission,
      options: filterValues.transmissions,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'base_color') {
    return {
      value: where.base_color,
      options: filterValues.base_colors,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'color') {
    return {
      value: where.color,
      options: filterValues.colors,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'tax_type') {
    return {
      value: where.tax_type,
      options: filterValues.tax_types,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'energylabel') {
    return {
      value: where.energylabel,
      options: filterValues.energylabels,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'max_towing_min') {
    return {
      value: where.max_towing_min,
      options: filterValues.max_towings,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }
  if (field === 'max_towing_max') {
    return {
      value: where.max_towing_max,
      options: filterValues.max_towings,
      handler: handleKeyValueToggle,
      arrayHandler: handleKeyValueArrayToggle,
    };
  }

  return {
    value: where[field],
    handler: handleKeyValueToggle,
    arrayHandler: handleKeyValueArrayToggle,
  };
};

export default useField;
